import { useMemo } from 'react';

import { selectSiteApps } from '@store/slices/settingsSlice.tsx';
import { selectIsSuperuser, selectUserPermissions } from '@store/slices/userSlice.tsx';
import { useAppSelector } from '@store/store.tsx';

export interface QuoteAccess {
  appEnabled: boolean;
  canRead: boolean;
  canWrite: boolean;
  canSend: boolean;
  canConvert: boolean;
}

export const useQuoteAccess = (): QuoteAccess => {
  const siteApps = useAppSelector(selectSiteApps) ?? [];
  const permissions = useAppSelector(selectUserPermissions) ?? [];
  const isSuperuser = useAppSelector(selectIsSuperuser);

  return useMemo(() => {
    const appEnabled = siteApps.includes('erp__sales__quotes');
    const permissionSet = new Set(permissions);
    const has = (permission: string) => isSuperuser || permissionSet.has(permission);

    return {
      appEnabled,
      canRead: appEnabled && has('quotes:read'),
      canWrite: appEnabled && has('quotes:write'),
      canSend: appEnabled && has('quotes:send'),
      canConvert: appEnabled && has('quotes:convert'),
    };
  }, [isSuperuser, permissions, siteApps]);
};
